// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '../static/flexible/flexible';
import '../static/css/reset.css';
import NutUI from '@nutui/nutui';
import '@nutui/nutui/dist/nutui.css';
import axios from 'axios'
import VueAxios from 'vue-axios'
import http from './utils/http'
Vue.config.productionTip = false
// 在入口文件中（main.js），导入组件库
import vueHashCalendar from 'vue-hash-calendar'
// 引入组件CSS样式
import 'vue-hash-calendar/lib/vue-hash-calendar.css'
// 注册组件库
Vue.use(vueHashCalendar)
NutUI.install(Vue);
Vue.use(VueAxios,axios);
/* eslint-disable no-new */
//判断是否是登录状态
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  let toRouter = {
    name: to.name
  }
  let fromRouter = {
    name: from.name
  }
  //路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.matched.some(m => m.meta.requireAuth)) {
    // console.log(localStorage.getItem('token'))
    if (sessionStorage.getItem('TOKEN') != null) {
      next()
    } else {
      next({
        path: '/',
        query: {
          Rurl: to.fullPath
        }
      })　　　　　
    }　　
  } else {　　　　　　
    next()　　
  }
});
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js